import { takeEvery } from 'redux-saga/effects';
import { fetchSearch } from './address-search';

export function* searchSaga() {
  yield takeEvery('FETCH_SEARCH', fetchSearch);
}
